export enum MDF_AND_EXCL_MODAL_SECTIONS {
  MODIFIERS = 'modifiers',
  EXCLUSIONS = 'exclusions',
}

export enum MDF_AND_EXCL_MODAL_MODIFIER {
  SINGLE = 'single',
  MULTIPLE = 'multiple',
}

export enum MDF_AND_EXCL_MODAL_EXCLUSION {
  SINGLE = 'single',
  MULTIPLE = 'multiple',
  NONE = 'none',
}
